import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { postiesPrimaryContentItemContent$key } from "scmp-app/queries/__generated__/postiesPrimaryContentItemContent.graphql";

import {
  Container,
  Content,
  Headline,
  StyledButton,
  StyledContentCoverImage,
  StyledEntityLink,
  StyledOffsetContainer,
} from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: postiesPrimaryContentItemContent$key;
};

export const ContentItemPostiesPrimary = forwardRef<HTMLDivElement, Props>(
  ({ className, customQueryParameters, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment postiesPrimaryContentItemContent on Content {
          ...entityLink
          ...contentCoverImageContent @arguments(withSize1200x800: true, withSize540x360: true)
          ...hooksContentItemProvidersContent @arguments(withHeadline: true)
        }
      `,
      reference_,
    );
    const providers = useContentItemProviders(content);

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink query={customQueryParameters} reference={content}>
          <StyledOffsetContainer borderRadius="20px">
            <StyledContentCoverImage
              reference={content}
              responsiveVariants={{
                desktopUp: "size1200x800",
                mobileUp: "size540x360",
                tabletUp: "size540x360",
              }}
            />
          </StyledOffsetContainer>
          <Content>
            <Headline>
              {providers.headline({
                hideTag: true,
                preferSocialHeadline: true,
              })}
            </Headline>
            <StyledButton variant="button">READ MORE</StyledButton>
          </Content>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemPostiesPrimary.displayName = "ContentItemPostiesPrimary";
